import axios from 'axios';

export const dashboardApi = async (config) => {
    return await axios.get(`${process.env.REACT_APP_GEMFINDER_URL_API}/api/dashboard/`, config);
};
export const dashboardStoneShareApi = async (config) => {
    return await axios.get(`${process.env.REACT_APP_STONE_SHARE_URL}/dashboard/`, config);
};
